import { render, staticRenderFns } from "./ViewShipments.vue?vue&type=template&id=61867315&lang=pug&"
import script from "./ViewShipments.vue?vue&type=script&lang=js&"
export * from "./ViewShipments.vue?vue&type=script&lang=js&"
import style0 from "./ViewShipments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports